/*
 * Jira Ticket:
 * Created Date: Thu, 26th Mar 2020, 10:43:45 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import create from './create';
import edit from './edit';
import icon from '@material-ui/icons/Map';

export default {
  list,
  create,
  edit,
  icon,
};
